import React, { useState } from 'react';

import './ContactLensColours.scss';

const COLOURS = [
  {
    key: 'aries-pink',
    name: 'Aries Pink',
    image: '/aries-pink.webp',
  },
  {
    key: 'virgo-choco',
    name: 'Virgo Choco',
    image: '/virgo-choco.webp',
  },
  {
    key: 'gemini-green',
    name: 'Gemini Green',
    image: '/gemini-green.webp',
  },
  {
    key: 'sagittarius-hazel',
    name: 'Sagittarius Hazel',
    image: '/sagittarius-hazel.webp',
  },
];

export const ContactLensColours = props => {
  const { baseImageUrl } = props;

  const [selectedColour, setSelectedColour] = useState('aries-pink');

  return (
    <div className="contact-lens-colours">
      <div className="contact-lens-colours__container">
        <h3 className="contact-lens-colours__title">Colours</h3>

        <ul className="contact-lens-colours__list">
          {COLOURS.map(({ key, name, image }) => (
            <li
              key={name}
              className="contact-lens-colours__item"
              data-selected={selectedColour === key}
              onClick={() => setSelectedColour(key)}
            >
              <img alt={name} src={`${baseImageUrl}/lens${image}`} />
              <p className="contact-lens-colours__item-name">{name}</p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
